module.exports = __webpack_public_path__ + "static/media/black_start_btn.af9bf8db.png";